import React from 'react';
import { ArrowRight, Sparkles, BookOpen, GraduationCap } from 'lucide-react';
import { courses } from '../mock';

const iconMap = { kids: Sparkles, teens: BookOpen, adults: GraduationCap };

const Courses = () => {
  return (
    <section id="cursos" className="bg-[#FDFAF0] py-20 md:py-24">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid lg:grid-cols-2 gap-8 items-end mb-12">
          <div>
            <span className="inline-block text-[11px] font-semibold tracking-widest text-[#5B84A6] px-3 py-1 border border-[#5B84A6]/40 rounded-full">
              ELEGÍ TU CAMINO
            </span>
            <h2 className="mt-5 font-serif text-4xl md:text-5xl leading-[1.05] font-bold text-[#1E3A5F]">
              Cursos para cada{' '}
              <span className="text-[#9B2C3B] italic">momento.</span>
            </h2>
          </div>
          <p className="text-[15px] text-[#1E3A5F]/70 leading-relaxed max-w-md">
            Aprender inglés puede ser una experiencia enriquecedora a cualquier edad. Encontrá el formato que va con vos.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {courses.map((c) => {
            const Icon = iconMap[c.id];
            return (
              <div
                key={c.id}
                className="rounded-3xl p-8 flex flex-col justify-between min-h-[320px] shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
                style={{ backgroundColor: c.color, color: c.text }}
              >
                <div>
                  <div className="flex items-center justify-between mb-8">
                    <span
                      className="h-10 w-10 rounded-full flex items-center justify-center"
                      style={{
                        backgroundColor:
                          c.id === 'kids' ? '#1E3A5F' : 'rgba(255,255,255,0.22)',
                        color: c.id === 'kids' ? '#E8B84A' : c.text,
                      }}
                    >
                      <Icon className="h-5 w-5" />
                    </span>
                    <span className="text-[11px] font-semibold tracking-wide opacity-85">
                      {c.age}
                    </span>
                  </div>
                  <h3 className="font-serif text-3xl font-bold">{c.name}</h3>
                  <p className="mt-3 text-[13.5px] leading-relaxed opacity-90">
                    {c.description}
                  </p>
                </div>
                <a
                  href="#contacto"
                  className="mt-8 inline-flex items-center gap-2 text-[13px] font-semibold w-fit"
                  style={{ color: c.text }}
                >
                  {c.cta}
                  <ArrowRight className="h-4 w-4" />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Courses;
